exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content{padding:1rem;border-radius:0 .5rem .5rem .5rem;border:solid 1px var(--border)}.tab-content.hidden{display:none}", ""]);

// exports
